<template>
    <div class="col-md-4 col-sm-12">
        <div class="search-result-row">
            <div class="search-result-img">
                <div class="search-result-left img-scale-in">
                    <a :href="$store.state.hrefPrefix + '/articles/' + article.slug"><img :src="article.blob.url" alt=""></a></div>
                <div class="search-result-right">
                    <h2><a :href="$store.state.hrefPrefix + '/category/' + article.category.slug">{{ article.category.name }}</a></h2>
                    <h3><a :href="$store.state.hrefPrefix + '/articles/' + article.slug">{{ article.title }}</a></h3>
                </div>
            </div>
            <p>{{ article.description }}</p>
            <ul>
                <li v-if="article.second_author == null">{{ $t('by') }} <strong>{{ article.author.name }}</strong></li>
                <li v-else>{{ $t('by') }} <strong>{{ article.author.name }}</strong> & <strong>{{ article.second_author.name }}</strong></li>
                <li>{{ article.date }}</li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    name: "CategoryColumnsMiddleFeatureArticle",
    props: {
        article: {
            type: Object,
            default: null
        }
    }
}
</script>

<style scoped>

</style>
